import { makeRequest } from "../http-common";

const FormDataService = {
  async get(id) {
    return makeRequest("get", `/form/${id}`);
  },

  async list() {
    return makeRequest("get", "/form/list");
  }
};

export default FormDataService;